import { makeAutoObservable } from 'mobx'
import { MAX_CRM_LENGTH } from 'shared/constants/auth'
import { CONTACTS_COUNTS, type IContactsCount } from 'shared/constants/contactsCounts'
import { CRMS, CrmEnum, type ICrm } from 'entities/Integrations'
import { type IResponseUsersProfilesUiSettings } from 'entities/Users/api/types'
import { type IParamsRegisterAnswersStep2 } from 'entities/Auth'
import { type IParamsRegisterGtmAnswersStep2 } from './type'

export class Step2Store {
  private _crm: ICrm | null = null
  private _contactsCount = ''

  constructor() {
    makeAutoObservable(this)
  }

  get payload() {
    return {
      answer_integration: this.crm?.name || '',
      answer_contactsCount: this._contactsCount,
    }
  }

  get answers(): IParamsRegisterAnswersStep2 {
    return {
      crm: this.crm?.value || '',
      contacts_number: this._contactsCount,
    }
  }

  get gtmAnswers(): IParamsRegisterGtmAnswersStep2 {
    return {
      crm: this.crm?.value || '',
      contacts_number: this._contactsCount,
    }
  }

  get isCompletedStep() {
    return !!this.crm && !!this.contactsCount
  }

  reset = () => {
    this._crm = null
    this._contactsCount = ''
  }

  initAnswers = ({ data }: IResponseUsersProfilesUiSettings) => {
    if (!data) return

    const { answer_integration, answer_contactsCount } = data.items.answers

    if (answer_integration) {
      const crm = this.crms.find((item) => item.name === answer_integration)
      if (crm) this._crm = crm

      if (crm) {
        this._crm = crm
      } else {
        this._crm = {
          id: CrmEnum.other,
          value: 'Other',
          name: answer_integration,
          icon: 'lightning2',
        }
      }
    }

    if (answer_contactsCount) this._contactsCount = answer_contactsCount
  }

  get crm() {
    return this._crm
  }

  get crmLength() {
    if (!this._crm) return 0
    return this._crm.name.length
  }

  get contactsCount() {
    return this._contactsCount
  }

  get crms(): ICrm[] {
    return CRMS
  }

  get contactsCounts(): IContactsCount[] {
    return CONTACTS_COUNTS
  }

  get isNextDisabled() {
    return Boolean(!this._crm || this._crm.name.length > MAX_CRM_LENGTH || !this._contactsCount)
  }

  setContactsCount = (value: string) => {
    this._contactsCount = value
  }

  setCrm = (crm: ICrm | null) => {
    if (crm && crm.name.length > MAX_CRM_LENGTH) return
    this._crm = crm
  }
}
